// extracted by mini-css-extract-plugin
export default {"cls1":"SocialActionsMenu-cls1___0c1715c35a090d2bb84","cls2":"SocialActionsMenu-cls2___e5a1c1c482c2e63d169 SocialActionsMenu-cls1___0c1715c35a090d2bb84"};